import { render, staticRenderFns } from "./detailsTemplate.vue?vue&type=template&id=2cdeba86&scoped=true"
import script from "./detailsTemplate.vue?vue&type=script&lang=js"
export * from "./detailsTemplate.vue?vue&type=script&lang=js"
import style0 from "./detailsTemplate.vue?vue&type=style&index=0&id=2cdeba86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdeba86",
  null
  
)

export default component.exports